import { motion } from 'framer-motion'
import './SupportSection.css'

// Modern SVG Icons
const TelegramIcon = () => (
    <svg viewBox="0 0 24 24" fill="currentColor" width="28" height="28">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z" />
    </svg>
)

const WhatsAppIcon = () => (
    <svg viewBox="0 0 24 24" fill="currentColor" width="28" height="28">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
)

const EmailIcon = () => (
    <svg viewBox="0 0 24 24" fill="currentColor" width="28" height="28">
        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
    </svg>
)

const HelpIcon = () => (
    <svg viewBox="0 0 24 24" fill="currentColor" width="48" height="48">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
    </svg>
)

const LightbulbIcon = () => (
    <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
        <path d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6A4.997 4.997 0 017 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z" />
    </svg>
)

const ClockIcon = () => (
    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
    </svg>
)

export default function SupportSection() {
    const supportChannels = [
        {
            name: 'Telegram',
            icon: TelegramIcon,
            description: 'Instant chat',
            link: 'https://t.me/tetherstreaam',
            color: '#0088cc',
            colorShadow: 'rgba(0, 136, 204, 0.3)'
        },
        {
            name: 'WhatsApp',
            icon: WhatsAppIcon,
            description: 'Direct message',
            link: 'https://wa.me/message/ZDTUK76LA35BN1',
            color: '#25D366',
            colorShadow: 'rgba(37, 211, 102, 0.3)'
        },
        {
            name: 'Email',
            icon: EmailIcon,
            description: 'Email support',
            link: 'mailto:support@flashusdt.com?subject=Transaction%20Support%20Request',
            color: '#EA4335',
            colorShadow: 'rgba(234, 67, 53, 0.3)'
        }
    ]

    return (
        <div className="support-section">
            <motion.div
                className="support-container"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.2 }}
            >
                <div className="support-header">
                    <div className="support-icon-wrapper">
                        <HelpIcon />
                    </div>
                    <h3 className="support-title">Need Help?</h3>
                    <p className="support-subtitle">
                        Transaction issues? Our support team is ready to assist.
                    </p>
                </div>

                <div className="support-channels">
                    {supportChannels.map((channel, index) => {
                        const IconComponent = channel.icon
                        return (
                            <motion.a
                                key={channel.name}
                                href={channel.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="support-channel-card"
                                style={{
                                    '--channel-color': channel.color,
                                    '--channel-color-shadow': channel.colorShadow
                                } as React.CSSProperties}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3, delay: 0.4 + index * 0.1 }}
                                whileTap={{ scale: 0.98 }}
                            >
                                <div className="channel-icon">
                                    <IconComponent />
                                </div>
                                <div className="channel-info">
                                    <h4 className="channel-name">{channel.name}</h4>
                                    <p className="channel-description">{channel.description}</p>
                                </div>
                                <div className="channel-arrow">
                                    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                                        <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
                                    </svg>
                                </div>
                            </motion.a>
                        )
                    })}
                </div>

                <div className="support-footer">
                    <motion.div
                        className="support-note"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.4, delay: 0.8 }}
                    >
                        <span className="note-icon">
                            <LightbulbIcon />
                        </span>
                        <p>
                            <strong>We help with:</strong> Transaction delays, failed purchases,
                            wallet issues, payment confirmations.
                        </p>
                    </motion.div>
                    <motion.div
                        className="response-time"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.4, delay: 0.9 }}
                    >
                        <span className="time-icon">
                            <ClockIcon />
                        </span>
                        <span>Response: <strong>5-10 min</strong></span>
                    </motion.div>
                </div>
            </motion.div>
        </div>
    )
}
